import { render, staticRenderFns } from "./CurriculumSUnits.vue?vue&type=template&id=2a627940&scoped=true&lang=pug&"
import script from "./CurriculumSUnits.vue?vue&type=script&lang=ts&"
export * from "./CurriculumSUnits.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumSUnits.vue?vue&type=style&index=0&id=2a627940&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a627940",
  null
  
)

export default component.exports